// extracted by mini-css-extract-plugin
export default {"Page":"Style_Page__7g2Np","Form":"Style_Form__dKS0f"};